import { useLazyQuery } from '@vue/apollo-composable'
import { queryEnquirePositionAllAndLifecycle } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'

export default function useHoldingSPS() {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(queryEnquirePositionAllAndLifecycle)

  onResult((res) => {
    const { enquirePositionAll, clientLifecycle } = res.data
    if (enquirePositionAll?.ok) {
      store.commit(HoldingsMutationTypes.SET_SPS_POS_PAGE_LIST, enquirePositionAll.data)
    }
    if (clientLifecycle?.ok) {
      store.commit(HoldingsMutationTypes.SET_CLIENT_LIFECYCLE, clientLifecycle.data)
    }
  })

  const queryHoldingSPSData = () => {
    const fundAccount = storage.rcGetItem(StorageType.local, 'userInfo')
    const param = {
      filter: {
        exchangeType: 'SPS',
        fundAccount
      },
      lifecycle: {
        clientId: fundAccount,
        productType: 'FCN'
      }
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(queryEnquirePositionAllAndLifecycle, param) || refetch(param)
  }

  return { queryHoldingSPSData, onResult, loading }
}
